"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultServerSideSchemaState = void 0;
exports.defaultServerSideSchemaState = {
    schemaStrings: ['{\"@context\": \"http://schema.org\",\"@type\": \"Organization\",\"name\": \"OKAY.com - Okay Property Agency Limited\",\"url\": \"https://devnew.okay.com\",\"logo\": \"https://devnew.okay.com/images/logos/okay_logo_light_328x50.png\",\"aggregateRating\": {\"@type\": \"AggregateRating\",\"worstRating\": \"1\",\"bestRating\": \"5\",\"ratingValue\": \"4.9\",\"ratingCount\": \"544\"}}'],
};
